import { render, staticRenderFns } from "./minusModal.vue?vue&type=template&id=4ca87cc1&"
import script from "./minusModal.vue?vue&type=script&lang=js&"
export * from "./minusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports